export const filterHiddenFields = (fields: string[]): string[] => fields.filter(key => !(key === 'id' || key.includes('.id') || key.includes('__typename')));
